
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 58 58","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M54.588 11.095a5.437 5.437 0 10-7.69-7.69L19.672 30.631l7.69 7.69 27.226-27.226zM19.672 30.631l-3.367 11.056 11.056-3.366M44.18 6.124l7.689 7.69M9.055 45.313H7.25a5.438 5.438 0 000 10.874h38.063","stroke":"#3B3B3B","stroke-width":"3.625"}}),_c('g',{attrs:{"clip-path":"url(#clip1)","stroke":"#000","stroke-width":"8.75"}},[_c('path',{attrs:{"d":"M83.442-40.442a21.225 21.225 0 00-30.159.205L-31.3 44.346l-10.325 40.279 40.28-10.33L83.236-10.29a21.215 21.215 0 00.205-30.153v0zM-31.294 44.34l29.977 29.925"}})])]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h58v58H0z"}})]),_c('clipPath',{attrs:{"id":"clip1"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(-46 -51)","d":"M0 0h140v140H0z"}})])])])
          )
        }
      }
    